import newsImg from "../../assets/news.jpg";
import libraryImg from "../../assets/library.jpg";
interface blogs {
  id: number;
  title: string;
  topic: string;
  description: string;
  image: string;
  publisher: string;
  date: string;
}

const Blog: blogs[] = [
  {
    id: 1,
    title: "Lorem Ipsum is simply dummy text",
    topic: "Topic 1",
    description:
      "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum. Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum. Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.",
    image: `${libraryImg}`,
    publisher: "Publisher Name",
    date: "2 Dec 2024",
  },
  {
    id: 2,
    title: "Why Lorem Ipsum",
    topic: "Topic 2",
    description:
      "Lorem Ipsum has been the industry's standard dummy text ever since the 1500s. Lorem Ipsum is simply dummy text of the printing and typesetting industry.",
    image: `${newsImg}`,
    publisher: "Publisher Name",
    date: "1 Dec 2024",
  },
  {
    id: 3,
    title: "The Evolution of Lorem Ipsum",
    topic: "Topic 3",
    description:
      "It has survived not only five centuries, but also the leap into electronic typesetting. Lorem Ipsum is simply dummy text of the printing and typesetting industry.",
    image: `${libraryImg}`,
    publisher: "Publisher Name",
    date: "29 Nov 2024",
  },
  {
    id: 4,
    title: "Lorem Ipsum is simply",
    topic: "Topic 1",
    description:
      "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum is simply dummy text of the printing and typesetting industry.",
    image: `${newsImg}`,
    publisher: "Publisher Name",
    date: "2 Dec 2024",
  },
  {
    id: 5,
    title: "Why Lorem Ipsum?",
    topic: "Topic 2",
    description:
      "Lorem Ipsum has been the industry's standard dummy text ever since the 1500s. Lorem Ipsum is simply dummy text of the printing and typesetting industry.",
    image: `${libraryImg}`,
    publisher: "Publisher Name",
    date: "1 Dec 2024",
  },
  {
    id: 6,
    title: "The Evolution of Lorem Ipsum",
    topic: "Topic 3",
    description:
      "It has survived not only five centuries, but also the leap into electronic typesetting. Lorem Ipsum is simply dummy text of the printing and typesetting industry.",
    image: `${newsImg}`,
    publisher: "Publisher Name",
    date: "29 Nov 2024",
  },
  {
    id: 7,
    title: "The way to program",
    topic: "Topic 1",
    description:
      "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum is simply dummy text of the printing and typesetting industry.",
    image: `${libraryImg}`,
    publisher: "Publisher Name",
    date: "2 Dec 2024",
  },
  {
    id: 8,
    title: "Why Lorem Ipsum?",
    topic: "Topic 2",
    description:
      "Lorem Ipsum has been the industry's standard dummy text ever since the 1500s. Lorem Ipsum is simply dummy text of the printing and typesetting industry.",
    image: `${newsImg}`,
    publisher: "Publisher Name",
    date: "1 Dec 2024",
  },
  {
    id: 9,
    title: "The Evolution of Lorem Ipsum",
    topic: "Topic 3",
    description:
      "It has survived not only five centuries, but also the leap into electronic typesetting. Lorem Ipsum is simply dummy text of the printing and typesetting industry.",
    image: `${newsImg}`,
    publisher: "Publisher Name",
    date: "29 Nov 2024",
  },
  {
    id: 10,
    title: "The Evolution of Lorem Ipsum",
    topic: "Topic 3",
    description:
      "It has survived not only five centuries, but also the leap into electronic typesetting. Lorem Ipsum is simply dummy text of the printing and typesetting industry.",
    image: `${libraryImg}`,
    publisher: "Publisher Name",
    date: "29 Nov 2024",
  },
];

export default Blog;
